/* global attachEvent, clickHandler, Swiper */
// *******************************************************************************
// Scroll to Section
// *******************************************************************************

attachEvent('.hero-secondary--about .btn', 'click', (ev) => {
  const { offsetTop } = document.querySelector(ev.target.hash);
  clickHandler(offsetTop);
  ev.preventDefault();
});

// *******************************************************************************
// Slider
// *******************************************************************************
const heroSliderElements = document.querySelectorAll('[data-slider="hero-secondary-slider"]');
const heroThumbsElements = document.querySelectorAll('[data-slider="hero-secondary-thumbs"]');

// *******************************************************************************
// 1.0 - Tumbnail slider
// *******************************************************************************
heroThumbsElements.forEach((el) => {
  const heroThumbsOptions = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    loop: true,
    navigation: {
      nextEl: '.hero-secondary__arrow--right',
      prevEl: '.hero-secondary__arrow--left',
    },
    breakpoints: {
      767: {
        spaceBetween: 32,
      },
    },
  };
  // eslint-disable-next-line no-unused-vars
  const heroThumbsSlider = new Swiper(el, heroThumbsOptions);
});

// *******************************************************************************
// 2.0 - Main slider
// *******************************************************************************
heroSliderElements.forEach((el, i) => {
  const mainSliderParent = el.closest('.hero-swiper-wrapper');
  const paginationElement = mainSliderParent.querySelector('.swiper-pagination');
  const heroSliderOptions = {
    slidesPerView: 1,
    spaceBetween: 32,
    loop: true,
    navigation: {
      nextEl: '.hero-secondary__arrow--right',
      prevEl: '.hero-secondary__arrow--left',
    },
    pagination: {
      el: paginationElement,
      clickable: true,
    },
    thumbs: {
      swiper: heroThumbsElements[i].swiper,
    },
  };
  // eslint-disable-next-line no-unused-vars
  const heroSlider = new Swiper(el, heroSliderOptions);
});

// *******************************************************************************
// 3.0 - Open Login-Form
// *******************************************************************************
attachEvent('.login-form-trigger', 'click', (ev) => {
  ev.preventDefault();
  const parentEle = ev.target.closest('.main');
  const loginForm = parentEle.querySelector('.login-form');
  loginForm.classList.add('is-open-login-form');
  document.body.classList.add('noscroll');
});
